/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsPaymentBankAccountViewModel } from './PaymentDetailsPaymentBankAccountViewModel';
import {
    PaymentDetailsPaymentBankAccountViewModelFromJSON,
    PaymentDetailsPaymentBankAccountViewModelFromJSONTyped,
    PaymentDetailsPaymentBankAccountViewModelToJSON,
} from './PaymentDetailsPaymentBankAccountViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsBankAccountPaymentViewModel
 */
export interface PaymentDetailsBankAccountPaymentViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsBankAccountPaymentViewModel
     */
    amount?: number;
    /**
     * 
     * @type {Array<PaymentDetailsPaymentBankAccountViewModel>}
     * @memberof PaymentDetailsBankAccountPaymentViewModel
     */
    clientPaymentBankAccounts: Array<PaymentDetailsPaymentBankAccountViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsPaymentBankAccountViewModel>}
     * @memberof PaymentDetailsBankAccountPaymentViewModel
     */
    thirdPartyPayeePaymentBankAccounts: Array<PaymentDetailsPaymentBankAccountViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsBankAccountPaymentViewModel interface.
 */
export function instanceOfPaymentDetailsBankAccountPaymentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientPaymentBankAccounts" in value;
    isInstance = isInstance && "thirdPartyPayeePaymentBankAccounts" in value;

    return isInstance;
}

export function PaymentDetailsBankAccountPaymentViewModelFromJSON(json: any): PaymentDetailsBankAccountPaymentViewModel {
    return PaymentDetailsBankAccountPaymentViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsBankAccountPaymentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsBankAccountPaymentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'clientPaymentBankAccounts': ((json['ClientPaymentBankAccounts'] as Array<any>).map(PaymentDetailsPaymentBankAccountViewModelFromJSON)),
        'thirdPartyPayeePaymentBankAccounts': ((json['ThirdPartyPayeePaymentBankAccounts'] as Array<any>).map(PaymentDetailsPaymentBankAccountViewModelFromJSON)),
    };
}

export function PaymentDetailsBankAccountPaymentViewModelToJSON(value?: PaymentDetailsBankAccountPaymentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Amount': value.amount,
        'ClientPaymentBankAccounts': ((value.clientPaymentBankAccounts as Array<any>).map(PaymentDetailsPaymentBankAccountViewModelToJSON)),
        'ThirdPartyPayeePaymentBankAccounts': ((value.thirdPartyPayeePaymentBankAccounts as Array<any>).map(PaymentDetailsPaymentBankAccountViewModelToJSON)),
    };
}

